import React from 'react';
import { Backspace } from '@mui/icons-material';
import ReportLayout from '../Components/Reports/ReportLayout';

interface TypeReportProps {
  Entete: string;
  TypeGroup: string;
}

const FRTransactionBackOffice: React.FC<TypeReportProps> = ({ Entete, TypeGroup }) => {
  return (
    <ReportLayout
      title={Entete}
      subtitle="Transactions back-office"
      icon={<Backspace />}
      endpoint="transaction-backoffice"
      extraParams={{ Type: TypeGroup }}
      showClientRange={false}
      showDateRange={true}
      showAgence={true}
      extraFields={[
        {
          key: 'ListGroup',
          label: 'Sélection utilisateur',
          type: 'multiselect',
          fetchUrl: 'client-typegroupeclient',
          fetchParams: { TypeGroup },
          valueField: 'Code',
          labelField: 'Libelle',
          joinParam: 'ListGroup',
        },
        {
          key: 'Status',
          label: 'Status opération',
          type: 'select',
          options: [
            { value: '0', label: '0-TOUTES LES OPERATIONS' },
            { value: '1', label: '1-ENCOURS DE VALIDATION' },
            { value: '2', label: '2-REJETEES' },
            { value: '3', label: '3-VALIDEES' },
            { value: '4', label: '4-COMPTABILISEES' },
          ],
        },
        {
          key: 'SensOpe',
          label: 'Sens opération',
          type: 'select',
          options: [
            { value: 'A', label: 'A-DEBITS ET CREDITS' },
            { value: 'C', label: 'C-CREDITS' },
            { value: 'D', label: 'D-DEBITS' },
          ],
        },
        { key: 'Min', label: 'Montant min', type: 'number', defaultValue: 0 },
        { key: 'Max', label: 'Montant max', type: 'number', defaultValue: 9999999999 },
      ]}
      paramTransform={(params) => ({
        ...params,
        Type: TypeGroup.concat(params.Status || '', params.SensOpe || ''),
      })}
      fileNamePrefix="rapport_transaction_backoffice"
    />
  );
};

export default FRTransactionBackOffice;
